import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import AsyncSelect from 'react-select/lib/Async';
import SelectService from '../../../services/SelectService';

class MergeToBatchModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      postValue: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
         }),
      ]),
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      handleSubmit: () => {
         console.log('submitted');
      },
      postValue: {},
      errorMsg: '',
   };

   constructor(props) {
      super(props);
      this.state = {};
      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
   }

   componentDidMount() {
      this.isLoading = true;
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   getOptions = async (newValue) => {
      const { postValue } = this.props;
      const formData = { searchFor: newValue, locationid: postValue.batchLocation, productid: postValue.productid };
      const options = [];
      this.isLoading = true;
      if (this.isLoading) {
         await SelectService.listBatchOptions(formData).then((response) => {
            if (response) {
               response.map(opt => (
                  options.push({
                     label: opt.batch_name,
                     value: opt.batch_id,
                  })
               ));
            }
         }).catch((error) => {
            console.log('Error: ', error.message);
         });
      }

      return options;
   }

   toggle() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         toggle, modal, postValue, handleChange, handleSubmit, errorMsg,
      } = this.props;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text modal__title">Merge Stock To Batch</h4>
               </div>
               <form onSubmit={handleSubmit} id="stocks_form">
                  <div className="modal__body p-t-10">
                  { errorMsg && (
                     <div className="notif_msg">
                        <Alert color="danger" className="alert--colored">
                        <div className="alert__content">
                           { parse(errorMsg) }
                        </div>
                        </Alert>
                     </div>
                     )
                  }
                  <div className="form form--vertical m-t-10">
                     <div className="form__form-group">
                        <span className="form__form-group-label">Batch Code <b className="text-danger m-l-5">*</b></span>
                        <div className="form__form-group-field">
                           <AsyncSelect
                              name="batch"
                              value={{
                                 label: postValue.batchText ? postValue.batchText : '',
                                 value: postValue.batchVal ? postValue.batchVal : '',
                              }}
                              onChange={e => handleChange(e, 'async')}
                              cacheOptions
                              loadOptions={this.getOptions}
                              defaultOptions
                              className="react-select"
                              classNamePrefix="react-select"
                              placeholder="Batch"
                           />
                        </div>
                     </div>
                  </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                     <Button color="primary">Submit</Button>
                     <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'stockForm',
})(withTranslation('common')(MergeToBatchModal));
